import gql from 'graphql-tag';

export const containerFollowUp = gql`
  fragment containerFollowUp on ContainerFollowUp {
    id
    referenceNumber
    buyOperationId
    container {
      id
      harold_number
      referenceNumber
      finalMargin {
        displayedVolume
      }
      buyOperationId
      sealedNumber
      sellOperationId
      qualities{
        id
        containerId
        operationQuality{
          id
          quality{
            id
            name
          }
        }
      }
      photos
      totalDeliveredTons
      tareWeight
    }
    containerId
    qualityFollowUps {
      qualityId
    }
    isPlannedLoading
    isPlannedDelivery
  }
`;

